<template>
    <loading-spinner v-if="loading" />
    <div v-else>
        <back-button class="ml-3" :route="backRoute" />
        <pre-assigned-routine v-if="!hasPreAssignedRoutineData" @complete="onCompletePreAssignedRoutine"
            :assignedRoutineId="assignedRoutineId" />
        <post-assigned-routine v-else @finish="onFinishAssignedRoutine" :assignedRoutineId="assignedRoutineId"
            :coach-id="coachId" ref="post" is-competence />
        <summary-assigned-routine-dialog :back-button="showBackBtn" @hide="onHideSummary"
            :assignedRoutineId="assignedRoutineId" ref="summary" is-competence />
    </div>
</template>

<script>

import { db } from "@/utils/Firebase";
import { mapMutations, mapState } from 'vuex'
import PreAssignedRoutine from "@/components/student/PreAssignedRoutine";
import AssignedRoutineDetail from '@/components/common/routines/AssignedRoutineDetail'
import PostAssignedRoutine from "@/components/student/PostAssignedRoutine";
import SummaryAssignedRoutineDialog from "@/components/student/SummaryAssignedRoutineDialog";
import LoadingSpinner from "@/components/common/LoadingSpinner";
import BackButton from "@/components/common/BackButton";

export default {
    components: {
        BackButton,
        LoadingSpinner,
        PreAssignedRoutine,
        AssignedRoutineDetail,
        PostAssignedRoutine,
        SummaryAssignedRoutineDialog,
    },
    data() {
        return {
            loading: false,
            assignedRoutine: null,
            showBackBtn: false,
        }
    },
    computed: {
        ...mapState(['currentRoutine']),
        assignedRoutineId(vm = this) {
            return vm.$route.params.uid
        },
        hasPreAssignedRoutineData(vm = this) {
            // return false
            return !!(vm.assignedRoutine?.advance?.pre)
        },
        hasPostAssignedRoutineData(vm = this) {
            // return true
            return !!(vm.assignedRoutine?.advance?.post)
        },
        showPostAssignedRoutine(vm = this) {
            if (!vm.hasPostAssignedRoutineData) {
                vm.setTitle('routines.last_step')
                return true
            } else {
                return false
            }
        },
        fixedBackBtn(vm = this) {
            return vm.hasPreAssignedRoutineData
        },
        coachId(vm = this) {
            return vm.currentRoutine?.coachId || vm.assignedRoutine?.coachId || null
        },
        backRoute(vm = this) {
            let route = { name: 'student.routines' }
            let date = vm.currentRoutine?.rawDate?.full || vm.assignedRoutine?.rawDate?.full || null
            if (!date) return route
            route.query = { date: date }
            return route
        }
    },
    async mounted() {
        const vm = this
        await vm.loadAssignedRoutine()
        if (!vm.hasPreAssignedRoutineData) vm.setTitle('routines.before_start')
    },
    methods: {
        ...mapMutations(['setCurrentRoutine', 'setTitle', 'setCurrentCarousel']),
        async loadAssignedRoutine() {
            const vm = this
            vm.loading = true
            let assignedRoutineRef = await db.collection('assignedRoutines').doc(vm.assignedRoutineId).get()
            console.log('assignedRoutineRef', assignedRoutineRef);
            vm.assignedRoutine = assignedRoutineRef.data()
            console.log('vm.assignedRoutine', vm.assignedRoutine);
            vm.setCurrentRoutine(vm.assignedRoutine)
            vm.loading = false
        },
        onCompletePreAssignedRoutine() {
            const vm = this
            vm.toast(vm.$t('routines.data_saved'))
            vm.loadAssignedRoutine()
        },
        onCompleteAssignedRoutine() {
            const vm = this
            if (!vm.hasPostAssignedRoutineData) vm.toast(vm.$t('routines.complete'))
            vm.loadAssignedRoutine()
        },
        onFinishAssignedRoutine() {
            const vm = this
            vm.$refs.summary.show()
        },
        onHideSummary() {
            const vm = this
            if (vm.$refs.post) vm.$refs.post.loadingContent = true
        },
        showSummary() {
            const vm = this
            vm.showBackBtn = true
            vm.$refs.summary.show()
        }
    },
    beforeRouteLeave(to, from, next) {
        const vm = this
        vm.setCurrentRoutine()
        vm.setCurrentCarousel()
        vm.setTitle()
        next()
    }
}
</script>